import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';

export interface DescriptionAudioResult {
  /** Public URL of the cached MP3 read-aloud of the book's description. */
  url: string;
}

/**
 * Read-aloud audio for book descriptions. The server synthesizes via
 * ElevenLabs on the first request and caches the result, so repeat calls
 * for the same description return instantly. POST (not GET) because the
 * first call has a generate-and-persist side effect server-side.
 */
export const audioService = {
  getDescriptionAudio(bookId: string): Promise<DescriptionAudioResult> {
    return apiRequest<DescriptionAudioResult>(apiRoutes.books.descriptionAudio(bookId), {
      method: 'POST',
    });
  },
};
